(() => {
  const updateNavigationState = (track, prevButton, nextButton) => {
    if (!track || !prevButton || !nextButton) return;

    const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
    prevButton.disabled = track.scrollLeft <= 2;
    nextButton.disabled = track.scrollLeft >= maxScrollLeft;
  };

  const getStep = (track) => {
    const firstCard = track.querySelector('.social-video-module__card');
    if (!firstCard) return track.clientWidth * 0.9;

    const styles = getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
    return firstCard.getBoundingClientRect().width + gap;
  };

  const initSocialVideoModule = (section) => {
    if (!section || section.dataset.socialVideoReady === 'true') return;

    const moduleRoot = section.querySelector('[data-social-video-module]');
    if (!moduleRoot) return;

    const track = moduleRoot.querySelector('[data-social-video-track]');
    const prevButton = moduleRoot.querySelector('[data-social-video-prev]');
    const nextButton = moduleRoot.querySelector('[data-social-video-next]');

    if (!track || !prevButton || !nextButton) return;

    section.querySelectorAll('[data-social-video-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const modalId = trigger.getAttribute('data-social-video-open');
        if (!modalId) return;

        requestAnimationFrame(() => {
          const modal = document.getElementById(modalId);
          const player = modal?.querySelector('[data-social-video-modal-player] video, [data-social-video-modal-player] iframe');
          if (!player) return;

          if (player.tagName === 'VIDEO') {
            const playPromise = player.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
            return;
          }

          if (player.classList.contains('js-youtube')) {
            player.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else {
            player.contentWindow?.postMessage('{"method":"play"}', '*');
          }
        });
      });
    });

    const scrollToDirection = (direction) => {
      track.scrollBy({
        left: getStep(track) * direction,
        behavior: 'smooth',
      });
    };

    prevButton.addEventListener('click', () => scrollToDirection(-1));
    nextButton.addEventListener('click', () => scrollToDirection(1));
    track.addEventListener('scroll', () => updateNavigationState(track, prevButton, nextButton), { passive: true });
    window.addEventListener('resize', () => updateNavigationState(track, prevButton, nextButton));

    updateNavigationState(track, prevButton, nextButton);
    section.dataset.socialVideoReady = 'true';
  };

  const initAllSocialVideoModules = (root = document) => {
    root.querySelectorAll('.shopify-section').forEach((section) => initSocialVideoModule(section));
  };

  document.addEventListener('DOMContentLoaded', () => initAllSocialVideoModules(document));
  document.addEventListener('shopify:section:load', (event) => initSocialVideoModule(event.target));
})();